import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { formatAmount, toastError, toastSuccess } from "../../../../../utils/constants";
import {
  getHostAndHostessDetails_action,
  insertUpdateHostAndHostess_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/hostAndHostess_action/hostAndHostess_action";
import Modal from "react-modal";
import $ from "jquery";
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import VendorDetails from "../../vendorDetails";
//
class HostHostessRequirements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      PowerConnectionList: [],
      Is_Agree: false,
      Remark: "",
      CGST: "",
      SGST: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      carPassessId: "",
      currentDate: moment().format("DD-MM-YYYY"),
      AgencyHostAndHostessID: "",
      AgencyDetails: [],
      CompanyName: "",
      ContactDetailsList: "",
      tableData: "",
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      exhDetails: {},
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addHostAndHostess()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });

    this.getHostAndHostessDetails();
    this.loadscript();
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back();
  }

  inputValidate() {
    const { Is_Agree } = this.state;

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({
        Is_AgreeErr: "Kindly agree the above disclaimer for Hoste & Hostess Services Provider",
      });
    }
  }

  getHostAndHostessDetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getHostAndHostessDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          this.setState({
            AgencyHostAndHostessID: data.noteDetails && data.noteDetails.length > 0 ? data.noteDetails[0]["AgencyHostAndHostessID"] : "",
            AgencyDetails: data.noteDetails || [],
            CompanyName: data.companyName && data.companyName.length > 0 ? data.companyName[0]["CompanyName"] : "",
            ContactDetailsList: data.contactDetails || [],
            exhDetails: data.exhDetails && data.exhDetails.length > 0 ? data.exhDetails[0] : {},
          });
          if (data.tableData != "") {
            const aaray = [];
            data.tableData.map((item) => {
              data.data.map((obj) => {
                if (item.HostAndHostessCategoryID == obj.HostAndHostessCategoryID) {
                  obj.IsCheckBox = 1;
                }
              });
            });
            this.setState({ tableData: data.data });
          } else {
            this.setState({ tableData: data.data });
          }
          if (data.getDetails != "") {
            this.setState({
              Remark: data.getDetails[0]["Remark"],
              Is_Agree: data.getDetails[0]["Is_Agree"],
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addHostAndHostess() {
    const { Remark, Is_Agree, AgencyHostAndHostessID, tableData } = this.state;
    const array = [];
    tableData.length > 0 && tableData != "" ? (
      tableData.map((data) => {
        if (data.IsCheckBox == 1) {
          array.push({
            HostAndHostessCategoryID: data.HostAndHostessCategoryID,
            Price: data.Price,
          });
        }
      })
    ) : (
      <></>
    );
    this.inputValidate();
    this.setState({ isLoading: true });

    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (Is_Agree) {
      this.props
        .insertUpdateHostAndHostess_action(
          Remark,
          Is_Agree,
          array,
          ManualFormsID,
          ServiceID,
          VendorDetails
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            setTimeout(() => {
              toastSuccess(
                this.state.StatusID == 0
                  ? "Host and Hostess Form Submitted Successfully"
                  : "Host and Hostess Form Updated Successfully"
              );
              this.handleCancel();
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toastError("Plase Enter mandatory feilds!");
      this.inputValidate();
      this.setState({ isLoading: false });
    }
  }

  Is_cheked(e, index) {
    const { tableData } = this.state;
    const event = e.target.checked;
    tableData.map((data, i) => {
      if (i === index) {
        if (event) {
          data.IsCheckBox = 1;
        } else {
          data.IsCheckBox = 0;
        }
      }
    });

    this.setState({ tableData: tableData });
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      AgencyHostAndHostessID,
      AgencyDetails,
      CompanyName,
      ContactDetailsList,
      tableData,
      StatusID,
      is_View,
      isHideSection, isOpenConfirmationModal, exhDetails
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    console.log("props", this.props);
    return (
      <>
        {isOpenConfirmationModal ? (
          <ConfirmationModal
            onConfirmation={this.handleConfirmation}
            message={this.state.confirmationObj}
          />
        ) : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? " with-dr-container" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="exb-top-space">
              <div className="row">
                <div class="card rounded-0 pt-1 shadow-none">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px" }}>
                      Hoste Hostess Requirement
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    {/* {!isHideSection && <ul style={{ lineHeight: "25px", textAlign: "left", padding: 0 }}>
                      <li>
                        1) The cost/rates and terms & conditions of utilizing the individual
                        services from the given service provider is solely discretion of exhibitors.
                      </li>
                      <li>
                        2) India ITME Society is only information facilitator for the service
                        provider & In no event shall INDIA ITME SOCIETY be liable for any direct,
                        indirect, punitive, incidental, special consequential issues, whatsoever
                        arising out of taking services with the above given service provider.
                      </li>
                    </ul>}
                    <VendorDetails />
                    {!isHideSection && <div className="row mt-4">
                      <h6 className="mt-2 ">
                        Host & Hostess Requirements{" "}
                        <span className="text-danger">
                          {" "}
                          Last Date Of Submission -{" "}
                          {this.props.location?.state?.ActualDeadline
                            ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                            : "-"}
                        </span>
                      </h6>
                    </div>}
                    </ul>} */}

                    <strong>
                      <p className="m-0">Exhibitor Details:</p>
                    </strong>
                    <div class="table-responsive mb-3">
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <tbody>
                          <tr>
                            <td style={{ width: "30%" }}>
                              <strong>Exhibiting Company Name:</strong>
                            </td>
                            <td>{exhDetails.CompanyName || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Booth No.:</strong>
                            </td>
                            <td>{exhDetails.StallName || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Hall No.:</strong>
                            </td>
                            <td>{exhDetails.HallName || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Contact Person:</strong>
                            </td>
                            <td>{exhDetails.ContactPerson || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Designation:</strong>
                            </td>
                            <td>{exhDetails.Designation || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Mobile:</strong>
                            </td>
                            <td>{exhDetails.Mobile || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Email ID:</strong>
                            </td>
                            <td>{exhDetails.Email || "-"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {!isHideSection && (
                      <div className="row mt-4">
                        <h6 className="mt-2 ">
                          Host & Hostess Requirements{" "}
                          <span className="text-danger">
                            {" "}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format(
                                  "DD-MM-YYYY",
                                )
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )}

                    {/* <div
                      class="table-responsive"
                      style={{ backgroundColor: "#ebebeb", marginBottom: "14px" }}
                    >
                      <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                        <strong>
                          <p className="m-0">Note:-</p>
                        </strong>
                        <p>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Food Need to be provided by the exhibitor</li>
                            <li>Taxes as per actuals.</li>
                          </ul>
                        </p>
                      </div>
                    </div> */}

                    {/* <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                      <p className="m-0">
                        Dear <strong>{CompanyName}</strong>,
                      </p>
                      <p className="m-0">
                        Kindly find the below details Agency for Hoste & Hostess Services Providers.
                      </p>
                      {AgencyDetails.map((data) => (
                        <>
                          <p className="m-0">Agency Name: {data.AgencyName}</p>
                          <p className="m-0">Email id: {data.AgencyEmail}</p>
                        </>
                      ))}
                    </div> */}

                    <div
                      class="table-responsive"
                      style={{ backgroundColor: "#ebebeb", marginBottom: "14px" }}
                    >
                      <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                        {/* <strong>
                          <p className="m-0">Contact Details:-</p>
                        </strong> */}
                        {ContactDetailsList.length > 0 ? (
                          ContactDetailsList.map((data) => (
                            <p className="m-0">
                              {data.Name}- {data.Mobile}
                            </p>
                          ))
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div class="table-responsive">
                      <p className="m-0">Charges for Hoste & Hostess Per Person per day as below</p>
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1 w-50">
                        <thead>
                          <tr>
                            <th style={{ width: "5%" }}>Action</th>
                            <th style={{ width: "15%" }}>Type</th>
                            <th style={{ width: "60%" }}>Particular</th>
                            {!isHideSection && (
                              <th className="text-center">
                                Cost{" "}
                                {JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91
                                  ? "(INR)"
                                  : "(USD)"}
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.length > 0 && tableData != "" ? (
                            tableData.map((data, i) => (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="m-0"
                                    checked={data.IsCheckBox}
                                    disabled={isDeadlinePassed || is_View}
                                    onChange={(e) => this.Is_cheked(e, i)}
                                  />
                                </td>
                                <td>{data.Type}</td>
                                <td>{data.CategoryName}</td>
                                {!isHideSection && (
                                  <td style={{ textAlign: "right" }}>
                                    {JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID ==
                                    91
                                      ? formatAmount(data.Price)
                                      : formatAmount(data.Price)}
                                  </td>
                                )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={4}>
                                No record found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div style={{ marginTop: "14px", textAlign: "left" }}>
                      <strong>
                        <p className="m-0 mb-2" style={{ textAlign: "left" }}>
                          Please Note:
                        </p>
                      </strong>
                      <ul
                        style={{
                          listStyleType: "disc",
                          paddingLeft: "20px",
                          lineHeight: "25px",
                          textAlign: "left",
                        }}
                      >
                        <li>
                          RATES MENTIONED ABOVE ARE ON HIRE BASIS AND APPLICABLE FOR SHOW DAYS ONLY.
                        </li>
                        <li>Exhibitor GSTN No. is Compulsory for the Invoice.</li>
                        <li>
                          Orders are valid only when accompanied with full payment before the
                          deadline.
                        </li>
                        <li>
                          Please make payment online through net banking and No Cash Accepted.
                        </li>
                      </ul>
                    </div>

                    <div className="terms-container" style={{ textAlign: "left" }}>
                      <h3 style={{ fontSize: "16px", marginBottom: "8px" }}>
                        Terms and Conditions:
                      </h3>
                      <ol style={{ paddingLeft: "20px", margin: 0 }}>
                        <li>
                          The minimum period of employment is average 8 hrs / day. 30 minutes lunch
                          time excluded.
                        </li>
                        <li>
                          The assigned staff will report directly to the exhibitor’s booth on-site.
                          On the first show day, staff will be present at least 1 hr before the show
                          opens.
                        </li>
                        <li>
                          Temporary staff should not be entrusted with handling of cash or other
                          valuable items.
                        </li>
                        <li>
                          Exhibitors will be responsible for the safety of the temporary staff (host
                          / hostess) while on duty on their booth.
                        </li>
                      </ol>
                    </div>
                    <div className="terms-container" style={{ textAlign: "left" }}>
                      <p style={{ margin: 0 }}>
                        Temporary staff will be properly dressed in formals i.e. Males will be
                        wearing formal and females wearing saris or business suits who will help the
                        exhibitors promote their products / services to their customers / buyers.
                        They will not extend any help to clean tables / wash utensils etc. They will
                        also not take the responsibility of serving alcohol, as this is not allowed
                        within the exhibition complex as per the rules & regulation.
                      </p>
                    </div>

                    {/* <div class="table-responsive">
                                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-3 w-50">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '5%' }}></th>
                                                        <th style={{ width: '80%' }}>Hoste for Exhibitor</th>
                                                        <th >Cost</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData.length > 0 && tableData != '' ?
                                                            tableData.map((data, i) => (
                                                                data.Type == 'Hoste' ?
                                                                    <tr>
                                                                        <td>
                                                                            <input type="checkbox" className="m-0"
                                                                                checked={data.IsCheckBox}
                                                                                onChange={(e) => this.Is_cheked(e, i)}
                                                                            />
                                                                        </td>
                                                                        <td>{data.CategoryName}</td>
                                                                        <td>{data.Price}</td>
                                                                    </tr>
                                                                    : <></>
                                                            ))
                                                            : <tr><td className="text-center" colSpan={8}>No record found</td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div> */}

                    {/* <div class="table-responsive">
                                            <p className="m-0">Charges for Hoste & Hostess Per Person per day as below</p>
                                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-3 w-50">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '5%' }}>Sr. No.</th>
                                                        <th style={{ width: '80%' }}>Particular</th>
                                                        <th >Cost {JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? '(INR)' : '(USD)'}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr >
                                                        <td className="text-center">1</td>
                                                        <td >Hoste</td>
                                                        <td className="text-center">{JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? '2000' : '30'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-center">2</td>
                                                        <td >Hostess</td>
                                                        <td className="text-center">{JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? '2500' : '50'}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div> */}
                  </div>
                </div>
                <div class="row m-1">
                  <form>
                    <strong>
                      {" "}
                      <label>Remark</label>
                    </strong>
                    <textarea
                      class="form-control"
                      value={Remark}
                      onChange={(e) => this.setState({ Remark: e.target.value })}
                      maxLength={300}
                      disabled={isDeadlinePassed || is_View}
                      rows="3"
                    ></textarea>
                    <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                      <input
                        type="checkbox"
                        checked={Is_Agree}
                        disabled={isDeadlinePassed || is_View}
                        onChange={(e) =>
                          this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                        }
                      />
                      <strong>
                        {" "}
                        I agree the above disclaimer for Hoste & Hostess Services Provider
                        <span className="required">*</span>.
                      </strong>
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_AgreeErr}
                      </span>
                    }
                  </form>
                </div>
              </div>
              {!isHideSection && (
                <div className="row">
                  {isDeadlinePassed && (
                    <span className="text-danger">
                      THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                    </span>
                  )}
                </div>
              )}

              {!isHideSection && (
                <div class="d-flex gap-1 justify-content-end mt-0">
                  <button
                    type="button"
                    className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                    style={{ marginRight: 10 }}
                    disabled={currentDate > DeadlineDate}
                    // onClick={() => this.addHostAndHostess()}
                    onClick={() =>
                      this.setState({
                        isOpenConfirmationModal: true,
                        confirmationObj: {
                          message: `Do you want to Submit?`,
                          buttonName: "Submit",
                          action: 0,
                        },
                        popArg: [],
                      })
                    }
                  >
                    Submit
                  </button>
                  <button
                    className="btn btn-gray rounded-1 d-block mt-3 mb-3"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, { getHostAndHostessDetails_action, insertUpdateHostAndHostess_action })(
    HostHostessRequirements
  )
);
